import { Row, message } from "antd";
// import PropTypes from "prop-types";
import classes from "../Pages.module.css";
import DataField from "./DataField";
import dayjs from "dayjs";
const BasicDetail = (props) => {
  const handleChange = (e, param) => {
    props.setData((data) => {
      const newdata = [...data["prodHdr"]];
      newdata[0][param] = e.target.value;
      return {
        ...data,
        prodHdr: newdata,
      };
    });
  };

  const handleSChange = (val, param) => {
    // console.log(val, "Truwwww");
    props.setData((data) => {
      const newdata = [...data["prodHdr"]];
      newdata[0][param] = val;
      return {
        ...data,
        prodHdr: newdata,
      };
    });
  };

  const handleDChange = (date, dateString, param) => {
    props.setData((data) => {
      const newdata = [...data["prodHdr"]];
      newdata[0][param] = dateString;
      return {
        ...data,
        prodHdr: newdata,
      };
    });
  };

  // const handleTChange = (time, timeString, param) => {
  //   props.setData((data) => {
  //     const newdata = [...data["reqHdr"]];
  //     // Assuming `timeString` is in the format "HH:mm:ss"
  //     newdata[0][param] = timeString;
  //     return {
  //       ...data,
  //       reqHdr: newdata,
  //     };
  //   });
  // };

  const handleDTChange = (date, dateString, param) => {
    props.setData((data) => {
      const newdata = [...data["prodHdr"]];
      newdata[0][param] = dateString;

      // Calculate the total time if both from_req_time and to_req_time are filled
      const fromTime =
        param === "from_time" ? dateString : data.prodHdr[0].from_time;
      const toTime = param === "to_time" ? dateString : data.prodHdr[0].to_time;

      if (fromTime && toTime) {
        const from = dayjs(fromTime, "DD-MM-YYYY HH:mm:ss");
        const to = dayjs(toTime, "DD-MM-YYYY HH:mm:ss");

        if (to.isAfter(from)) {
          const diff = to.diff(from, "hour", true); // Calculate the difference in hours
          newdata[0]["no_of_hr"] = diff.toFixed(2); // Update the total with the calculated difference
        } else {
          message.error("To Time should be after From Time");
          newdata[0]["no_of_hr"] = "";
        }
      }

      return {
        ...data,
        prodHdr: newdata,
      };
    });
  };

  return (
    <div>
      <p></p>
      <Row className={props.editMode ? classes["RowDEX"] : classes["RowD"]}>
        {!props.create && (
          <DataField
            editMode={props.editMode}
            lg={12}
            md={24}
            name="Requisition Code"
            param="REQ_CODE"
            value={props.data.req_code}
          />
        )}

        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleDChange}
          type="Date"
          id="exec_date"
          required="True"
          name="Excution Date"
          param="exec_date"
          value={props.data.exec_date}
          rules={[{ message: "missing name" }]}
        />

        {/* <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleTChange}
          type="Time"
          id="Req_time"
          required="True"
          name="Requisition Time"
          param="Req_time"
          value={props.data.req_time}
          rules={[{ message: "missing name" }]}
        /> */}

        <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleDTChange}
          type="DateTime"
          id="from_time"
          required="True"
          name="From Time"
          param="from_time"
          value={props.data.from_time}
          rules={[{ message: "missing name" }]}
        />

        <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleDTChange}
          type="DateTime"
          id="to_time"
          required="True"
          name="To Time"
          param="to_time"
          value={props.data.to_time}
          rules={[{ message: "missing name" }]}
        />

        <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="No Of Hrs"
          id="Department"
          required="True"
          param="no_of_hr"
          value={props.data.no_of_hr}
          disabled={true}
        />

        <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleSChange}
          options={props.ad.SHIFT_CD}
          type="Select"
          name="Shift"
          id="Shift"
          required="True"
          param="shift_cd"
          value={props.data.shift_cd}
        />

        <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleSChange}
          options={props.ad.ROLLING_MAN}
          type="Select"
          name="Meltor Incharge"
          required="True"
          id="melterincharge"
          param="melter_incharge"
          value={props.data.melter_incharge}
        />

        <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleSChange}
          options={props.ad.ROLLING_MAN}
          type="Select"
          name="Scraper"
          required="True"
          id="scraper"
          param="scraper"
          value={props.data.scraper}
        />

        <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleSChange}
          options={props.ad.ROLLING_MAN}
          type="Select"
          name="Chemical Incharge"
          required="True"
          id="chemicalcode"
          param="chemical_incharge"
          value={props.data.chemical_incharge}
        />

        <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleSChange}
          options={props.ad.FURNANCE_CD}
          type="Select"
          name="Furnace"
          required="True"
          id="furnace"
          param="furnace"
          value={props.data.furnace}
        />

        <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleSChange}
          options={props.ad.CONTRACT_CD}
          type="Select"
          name="Contractor"
          required="True"
          id="contractor_cd"
          param="contractor_cd"
          value={props.data.contractor_cd}
        />
        <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Patch No"
          id="patch_no"
          required="True"
          param="patch_no"
          value={props.data.patch_no}
        />

        <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleSChange}
          options={props.ad.ROLLING_MAN}
          type="Select"
          name="Produced"
          required="True"
          id="produced_by"
          param="produced_by"
          value={props.data.produced_by}
        />

        <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Electricity consumed"
          id="elec_cons"
          required="True"
          param="elec_cons"
          value={props.data.elec_cons}
        />
      </Row>
    </div>
  );
};

export default BasicDetail;
